import { render, staticRenderFns } from "./HashtagTextArea.vue?vue&type=template&id=15a40b01"
import script from "./HashtagTextArea.vue?vue&type=script&lang=js"
export * from "./HashtagTextArea.vue?vue&type=script&lang=js"
import style0 from "./HashtagTextArea.vue?vue&type=style&index=0&id=15a40b01&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports